import React from 'react';
import { Route } from 'react-router-dom';
import DialpadDesignRoutes from './DialpadDesign/routes';
const routes = () => [<DialpadDesignRoutes key="DialpadDesignRoutes" />];

const DialpadDesignRoute = () => <Route component={routes} />;

export default DialpadDesignRoute;



// WEBPACK FOOTER //
// src/modules/screens/dialpadDesign/routes.js